module.exports = __webpack_public_path__ + "img/how.af589a76.svg";